import React from 'react';
import { Link } from 'react-router-dom';
import News from '../components/News';
import SEO from '../components/SEO';

function Home() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Pharmaceutical Database',
    url: 'http://localhost:3000',
    description: 'Comprehensive pharmaceutical information from FDA, ClinicalTrials.gov, ChEBI, ChEMBL, PubChem, RxNorm, and DailyMed',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'http://localhost:3000/drugs?search={search_term_string}'
      },
      'query-input': 'required name=search_term_string'
    },
    mainEntity: {
      '@type': 'MedicalWebPage',
      '@id': 'http://localhost:3000',
      about: {
        '@type': 'MedicalCondition',
        name: 'Drug Information and Clinical Research'
      }
    }
  };

  return (
    <div className="page-container">
      <SEO
        title="Pharmaceutical Database - FDA Drugs, Clinical Trials & Medical Research"
        description="Access comprehensive pharmaceutical data from FDA Drugs@FDA, ClinicalTrials.gov, ChEBI, ChEMBL, PubChem, RxNorm, and DailyMed. Search drugs, clinical trials, chemical compounds, and medical research."
        keywords="pharmaceutical database, FDA drugs, clinical trials, drug information, ChEBI, ChEMBL, PubChem, RxNorm, DailyMed, Orange Book, drug search, medical research, drug approval, pharmaceutical research, health database"
        canonical="/"
        structuredData={structuredData}
      />
      <h1 className="page-title">Welcome to Pharmaceutical Database</h1>
      <p className="page-description">
        Access comprehensive pharmaceutical information from 8 trusted databases including
        FDA, NIH, PubChem, RxNorm, DailyMed, ClinicalTrials.gov, ChEBI, and ChEMBL.
      </p>

      <div className="features-grid">
        <Link to="/drugs" className="feature-card">
          <h2>🔍 FDA Drug Search</h2>
          <p>
            Search FDA-approved drugs with detailed information including approval history,
            safety data, adverse events, and drug labels from Drugs@FDA database.
          </p>
        </Link>

        <Link to="/trials" className="feature-card">
          <h2>📋 Clinical Trials</h2>
          <p>
            Browse ongoing and completed clinical trials from ClinicalTrials.gov.
            Search by condition, intervention, or trial identifier.
          </p>
        </Link>

        <Link to="/chemicals" className="feature-card">
          <h2>⚗️ Chemical Data</h2>
          <p>
            Explore chemical entities and bioactivity data from ChEBI and ChEMBL databases.
            Search by name, structure, or molecular properties.
          </p>
        </Link>

        <Link to="/orangebook" className="feature-card">
          <h2>📖 Orange Book</h2>
          <p>
            Find therapeutic equivalence evaluations and generic drug information from
            FDA's Orange Book database.
          </p>
        </Link>

        <Link to="/pubchem" className="feature-card">
          <h2>🧪 PubChem</h2>
          <p>
            Search the world's largest collection of freely accessible chemical information
            with compounds, properties, structures, and biological activities.
          </p>
        </Link>

        <Link to="/rxnorm" className="feature-card">
          <h2>💊 RxNorm</h2>
          <p>
            Access normalized drug names, find drug interactions, discover generic and
            brand name alternatives from NIH's RxNorm database.
          </p>
        </Link>

        <Link to="/dailymed" className="feature-card">
          <h2>📄 DailyMed Labels</h2>
          <p>
            View official FDA-approved drug labeling and package inserts. Access
            comprehensive prescribing information and safety data.
          </p>
        </Link>
      </div>

      <News type="combined" limit={12} />

      <div className="info-box" style={{ backgroundColor: '#ecf0f1', borderLeftColor: '#95a5a6' }}>
        <h3 style={{ color: '#2c3e50' }}>About the Data Sources</h3>
        <ul style={{ color: '#7f8c8d' }}>
          <li>📊 <strong>FDA Drugs@FDA:</strong> Official FDA-approved drug products and their approval history</li>
          <li>📖 <strong>FDA Orange Book:</strong> Approved drug products with therapeutic equivalence evaluations</li>
          <li>📄 <strong>DailyMed:</strong> Official FDA label information and package inserts</li>
          <li>🔬 <strong>ClinicalTrials.gov:</strong> Database of clinical studies conducted worldwide (NIH)</li>
          <li>🧪 <strong>PubChem:</strong> Chemical information database from NCBI with millions of compounds</li>
          <li>💊 <strong>RxNorm:</strong> Normalized drug naming system from National Library of Medicine</li>
          <li>⚗️ <strong>ChEBI:</strong> Chemical Entities of Biological Interest from EMBL-EBI</li>
          <li>🧬 <strong>ChEMBL:</strong> Bioactive molecules with drug-like properties from EMBL-EBI</li>
        </ul>
      </div>

      <div className="info-box" style={{ backgroundColor: '#d1ecf1', borderLeftColor: '#17a2b8' }}>
        <h3 style={{ color: '#0c5460' }}>✨ New Database Tools Added! <span className="badge badge-new">NEW</span></h3>
        <p style={{ color: '#0c5460', lineHeight: '1.8', fontSize: '1rem' }}>
          We've added 3 powerful new databases: <strong>PubChem</strong> for comprehensive chemical data,
          <strong> RxNorm</strong> for drug name normalization and interactions, and <strong>DailyMed</strong> for
          official FDA drug labels. Explore these tools using the navigation menu above!
        </p>
      </div>
    </div>
  );
}

export default Home;
